import React, { ReactElement } from 'react'
import { IColorTheme } from '../../../types/itemTypes'
import ItemGridSelect from './ItemGridSelect'

export enum ItemOrder {
  Low = 'low',
  High = 'high',
}
interface IOrderSelectProps {
  selectedOrder: ItemOrder | undefined
  setSelectedOrder: (order?: ItemOrder) => void
  colorTheme?: Partial<IColorTheme>
}
export default function OrderSelect(props: IOrderSelectProps): ReactElement {
  const { selectedOrder, setSelectedOrder, colorTheme } = props

  const options = [
    {
      value: ItemOrder.Low,
      label: 'Lowest price first',
    },
    {
      value: ItemOrder.High,
      label: 'Highest price first',
    },
  ]

  const selectedOption = options.filter(
    (option) => option.value === selectedOrder,
  )[0]

  const selected = selectedOrder
    ? {
      value: selectedOrder,
      label: selectedOption.label,
    }
    : undefined

  return (
    <ItemGridSelect<ItemOrder>
      placeholder="Popular"
      selected={selected}
      options={options}
      onSelect={(option): void => {
        if (option) {
          setSelectedOrder(option.value)
        } else {
          setSelectedOrder()
        }
      }}
      colorTheme={colorTheme}
    />
  )
}
